import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {CustomRow} from '../table/columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {parametersColumns} from './columns/_columns'
import {Parameter} from '../core/_models'
import {ParametersListLoading} from '../components/loading/ParametersListLoading'
import {ParametersListPagination} from '../components/pagination/ParametersListPagination'
import {KTCardBody} from '../../../../../../../../_metronic/helpers'

const ParametersTable = () => {
  const parameters = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => parameters, [parameters])
  const columns = useMemo(() => parametersColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_Parameters'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Parameter>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {/* {rows.length > 0 ? (
              rows.map((row: Row<Parameter>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )} */}
            <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ParametersListPagination />
      {isLoading && <ParametersListLoading />}
    </KTCardBody>
  )
}

export {ParametersTable}
